import { hasPermission } from './hasPermission';
import { isAdmin } from './isAdmin';
import { hasDeductibleMonitoring } from './hasDeductibleMonitoring';

export const permissions = {
  hasPermission,
  isAdmin,
  hasDeductibleMonitoring,
};
